import { AFFILIATE_DASHBOARD_API } from 'modules/affiliate-dashboard/api/affiliate-dashboard-api'
import { AffiliateDashboardFilterWithTagInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface'
import { AffiliateDashboardLeadsApiInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-leads-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface'
import { getFilterQueryString } from 'shared/utils/api/get-filter-query-string'
import { getPaginationAndFilterQueryString } from 'shared/utils/api/get-pagination-and-filter-query-string'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'

interface UseAffiliateDashboardLeadsInterface extends SwrPaginationInterface {
  filter: AffiliateDashboardFilterWithTagInterface
}

export const useAffiliateDashboardLeads = ({
  filter,
  limit,
  pagination,
}: UseAffiliateDashboardLeadsInterface) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, AffiliateDashboardLeadsApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const leadsFilter = {
    affiliateTag: filter.affiliateTag,
    dateTill: filter.dateTill,
    dateSince: filter.dateSince,
  }

  const { data: affiliateLeads } = useControlledSwr(() => {
    if (!user || filter.dateSince === null) return
    return [
      `${AFFILIATE_DASHBOARD_API}/leads/list${
        filter.vendorId ? `/${filter.vendorId}` : ''
      }?${getPaginationAndFilterQueryString({ limit, pagination, filter: leadsFilter })}`,
      RequestModuleEnum.Contacts,
    ]
  }, fetcher)

  const { data: counter } = useSWR<CountInterface>(() => {
    if (!user || filter.dateSince === null) return

    return `${AFFILIATE_DASHBOARD_API}/leads/count${
      filter.vendorId ? `/${filter.vendorId}` : ''
    }?${getFilterQueryString({ filter: leadsFilter })}`
  }, baseFetcher)

  return { affiliateLeads, counter }
}
